import { BellRing } from "lucide-react";

import { AnnouncementCard } from "@/components/announcements/AnnouncementCard";
import { PageHeading } from "@/components/ui/PageHeading";
import { PlaceholderState } from "@/components/ui/PlaceholderState";
import type { Announcement } from "@/data/types";
import { useAnnouncements } from "@/hooks/useAnnouncements";

function List({ items }: { items: Announcement[] }) {
  return (
    <div className="space-y-3">
      {items.map((a) => (
        <AnnouncementCard key={a.id} a={a} />
      ))}
    </div>
  );
}

export function AnnouncementsPage() {
  const items = useAnnouncements();
  const pinned = items.filter((a) => a.isPinned);
  const recent = items.filter((a) => !a.isPinned);

  return (
    <div>
      <PageHeading
        eyebrow="Notices"
        title="Masjid Announcements"
        subtitle="Jummah times, Janaza notices, Eid prayers and meeting updates."
      />

      {items.length === 0 ? (
        <PlaceholderState
          icon={<BellRing size={28} strokeWidth={1.5} />}
          title="No notices yet"
          message="Announcements from the Imam Sahab and committee will be posted here. Please check back after Jummah."
        />
      ) : (
        <div className="pb-8">
          {pinned.length > 0 ? (
            <section className="mb-6">
              <div className="label-eyebrow mb-3">Pinned</div>
              <List items={pinned} />
            </section>
          ) : null}
          {recent.length > 0 ? (
            <section>
              {pinned.length > 0 ? (
                <div className="label-eyebrow mb-3">Recent</div>
              ) : null}
              <List items={recent} />
            </section>
          ) : null}
        </div>
      )}
    </div>
  );
}
